import React, { Dispatch, SetStateAction } from 'react';
import data from '@emoji-mart/data';
import { CustomEditor } from '../../../../models/slate-editor';
import { BaseEmoji, PickerProps } from 'emoji-mart';
// TODO Type definitions are outdated
// https://github.com/missive/emoji-mart/issues/576
// Out temp solution is to ignore errors until defs are there
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Picker from '@emoji-mart/react';

export type EmojiPickerViewProps = Omit<PickerProps, 'data' | 'ref'> & {
  editor: CustomEditor;
  onEmojiSelect?: (e: BaseEmoji) => void;
  closeEmoji: Dispatch<SetStateAction<boolean>>;
};

export const EmojiPickerView = (props: EmojiPickerViewProps): JSX.Element => {
  return <Picker {...props} data={data} />;
};
